// extracted by mini-css-extract-plugin
module.exports = {"popup_login_form__header":"LoginForm_popup_login_form__header__1KpEm","popup_login_form__wrong_auth_data_message":"LoginForm_popup_login_form__wrong_auth_data_message__1ihY5"};